import { pick } from 'lodash'
import { STORE_SUGGESTED_OFFER } from 'common/constants/actionTypes'

export default function (state = {}, action) {
  switch (action.type) {
    case STORE_SUGGESTED_OFFER:
      return pick(action.payload, [
        'suggested_offer_low',
        'suggested_offer_high',
      ])
    default:
      return state
  }
}
